import { render, staticRenderFns } from "./PreliminarySelectQuestion.vue?vue&type=template&id=c6f81cec&scoped=true&"
import script from "./PreliminarySelectQuestion.vue?vue&type=script&lang=js&"
export * from "./PreliminarySelectQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f81cec",
  null
  
)

export default component.exports